import request from '@/utils/http';
// 指标库列表查询
export const perQuotMana = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/performanceQuotasManagerPage`,
        method: 'post',
        data: params
    });
};
// 指标库新增
export const addQuota = (params) => {
    return request({
        url: `/api-srm-web/performance/performanceQuota`,
        method: 'post',
        data: params
    });
};
// 指标库修改
export const editQuota = (id, params) => {
    return request({
        url: `/api-srm-web/performance/performanceQuota/${id}`,
        method: 'put',
        data: params
    });
};
// 指标库导出
export const exportQuotas = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/exportperformanceQuotas`,
        method: 'post',
        data: params
    });
};
// 指标库配置查询
export const conperQuotMana = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/performanceQuotaConfigsManagerPage`,
        method: 'post',
        data: params
    });
};
// 指标库设置新增
export const conaddQuota = (params) => {
    return request({
        url: `/api-srm-web/performance/performanceQuotaConfig`,
        method: 'post',
        data: params
    });
};
// 指标库设置修改
export const coneditQuota = (params, id) => {
    return request({
        url: `/api-srm-web/performance/performanceQuotaConfig/${id}`,
        method: 'put',
        data: params
    });
};
// 指标库批量删除
export const delBatch = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/performanceQuotasDeleteBatch`,
        method: 'post',
        data: params
    });
};
// 指标库批量删除
export const condelBatch = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/quotaConfigDeleteBatch`,
        method: 'post',
        data: params
    });
};
// 管理端日常考核查询接口
export const daylist = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/performanceDailyAssessmentsManagerPage`,
        method: 'post',
        data: params
    });
};
// 管理端日常考核复核接口
export const dlExamine = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/dailyAssessmentsExamine`,
        method: 'post',
        data: params
    });
};
// 日常考核审核申诉接口
export const dlApproval = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/dailyAssessmentsApproval`,
        method: 'post',
        data: params
    });
};
// 管理端日常考核MIP流程审批接口
export const dlCreateDraft = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/dailyIflowCreateDraft`,
        method: 'post',
        data: params
    });
};
// 管理端日常考核查看原因
export const dlreview = (params) => {
    return request({
        url: `/api-srm-web/performance/performanceExamineDerates`,
        method: 'post',
        data: params
    });
};
// 整改任务配置列表查询
export const conTasklist = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/performanceScoreHeadsManagerPage`,
        method: 'post',
        data: params
    });
};
// 整改任务配置列表新增
export const addTasklist = (params) => {
    return request({
        url: `/api-srm-web/performance/performanceScoreHead`,
        method: 'post',
        data: params
    });
};
// 整改任务配置列表编辑
export const editTasklist = (params, id) => {
    return request({
        url: `/api-srm-web/performance/performanceScoreHead/${id}`,
        method: 'put',
        data: params
    });
};
// 整改任务评分权重新增接口
export const addTaskconDetail = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/scoreDetailInsertBatch`,
        method: 'post',
        data: params
    });
};
// 整改任务评分权重删除接口
export const delTaskconDetail = (params) => {
    return request({
        url: `/api-srm-web/performance/performanceScoreDetail`,
        method: 'delete',
        data: params
    });
};
// 整改任务评分权重编辑接口
export const editTaskconDetail = (params, id) => {
    return request({
        url: `/api-srm-web/performance/portal/scoreDetailBatchUpdate`,
        method: 'post',
        data: params
    });
};
// 整改任务评分权重查询接口
export const listTaskcon = (params) => {
    return request({
        url: `/api-srm-web/performance/performanceScoreDetails`,
        method: 'post',
        data: params
    });
};
// 管理端日常考核导出接口
export const exportdatli = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/exportDailyAssessments`,
        method: 'post',
        data: params
    });
};
// 整改任务配置批量删除
export const HeadDelete = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/scoreHeadDeleteBatch`,
        method: 'post',
        data: params
    });
};
// 评分权重批量删除
export const DeleteBatch = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/scoreDetailDeleteBatch`,
        method: 'post',
        data: params
    });
};

// 工作台-日考核头部查询
export const customerDailyHeader = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/customerDailyHeader`,
        method: 'post',
        data: params
    });
};
// 工作台-日常考核列表查询集合
export const customerDailyAssessments = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/customerDailyAssessments`,
        method: 'post',
        data: params
    });
};
// 工作台-日常考核查看明细
export const customerDailyAssessment = (id) => {
    return request({
        url: `/api-srm-web/performance/portal/customerDailyAssessment/${id}`,
        method: 'get'
    });
};
// 工作台-日常考核提交申诉
export const customerDailyAssessmentsAppeal = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/customerDailyAssessmentsAppeal`,
        method: 'post',
        data: params
    });
};
// 工作台-日常考核确认
export const mobileDailyDetermine = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/mobileDailyDetermine`,
        method: 'post',
        data: params
    });
};
// 工作台-日常考核确认查看申诉
export const mobileExamineDerates = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/mobileExamineDerates`,
        method: 'post',
        data: params
    });
};
// 日考核-下发
export const pushToSupplier = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/dailyAssessmentPushToSupplierWorkbench`,
        method: 'post',
        data: params
    });
};

// 供应商绩效延迟配置表新增
export const performanceDelayConfig = (params) => {
    return request({
        url: `/api-srm-web/performance/performanceDelayConfig`,
        method: 'post',
        data: params
    });
};
// 供应商绩效延迟配置表查询
export const performanceDelayConfigs = (params) => {
    return request({
        url: `/api-srm-web/performance/performanceDelayConfigs`,
        method: 'post',
        data: params
    });
};
// 供应商绩效延迟配置表修改
export const editPerformanceDelayConfig = (params, id) => {
    return request({
        url: `/api-srm-web/performance/performanceDelayConfig/${id}`,
        method: 'put',
        data: params
    });
};
// 供应商绩效延迟配置表删除
export const delPerformanceDelayConfig = (id) => {
    return request({
        url: `/api-srm-web/performance/performanceDelayConfig/${id}`,
        method: 'delete'
    });
};